import { atom } from "recoil";
import { localStoragePersistenceEffect } from "../atomEffects/localStoragePersistenceEffect";

export const countryAtom = atom({
  key: "sgg_country",
  default: "US",
  effects: [localStoragePersistenceEffect("sgg_country")],
});
